module.exports = __webpack_public_path__ + "media/application/images/svgs/plus-197e0ee2505ffd585ab0e329be036c7b.svg";